import React from 'react'
import GridModel from '../../components/UI/GridModel/GridModel'

        const Shift = (props) => {

    const lckrTp = props.shift

    const cols = lckrTp != null ? [
        {label: "ساعت شروع", value: lckrTp.startTime},
        {label: "ساعت پایان", value: lckrTp.endTime}
    ] :
            []


    return (
            <GridModel edit={(event) => props.edit(event, lckrTp.id)} hasEdit={true} model={cols} />
            )
}
export default Shift